import Text from 'components/Text/Text';
import React from 'react';
import CreateSubcategoryModalControlPanel from './components/CreateSubcategoryModalControlPanel/CreateSubcategoryModalControlPanel';
import CreateSubcategoryModalForm from './components/CreateSubcategoryModalForm/CreateSubcategoryModalForm';
import style from './CreateSubcategoryModal.module.scss';

const CreateSubcategoryModal: React.FC = () => {
	return (
		<div className={style.container} data-test="CreateSubcategoryModal">
			<Text translationNameSpace="form" translationKey="createSubcategoryLabel" size="xxl" weight="bold" />
			<CreateSubcategoryModalControlPanel />
			<CreateSubcategoryModalForm />
		</div>
	);
};

export default CreateSubcategoryModal;
